function initAutocomplete() {
	const input = document.getElementById("location-search-input-field")
	if (!input) return

	const autocomplete = new google.maps.places.AutocompleteService(input, {
		types: ["(regions)"], // Or use ['geocode'] for street-level addresses
		componentRestrictions: { country: "us" }, // optional
	})

	autocomplete.addListener("place_changed", () => {
		const place = autocomplete.getPlace()
		// Optionally update hidden inputs or perform a search
	})
}

function initService() {
	const input = document.getElementById("location-search-input-field");
	const form = document.getElementById("location-search-form")
	const resultsContainer = document.querySelector('ul#results-list');
	const service = new google.maps.places.AutocompleteService();

	if (!input || !resultsContainer) return;

	const displaySuggestions = function (predictions, status) {
		if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
			resultsContainer.innerHTML = "";
			return;
		}
		var cities = predictions?.filter(({ types }) =>
			types.includes('locality') ||
			types.includes('postal_code') ||
			types.includes('political')
		);
		if(!cities || cities.length === 0) 
			return resultsContainer.innerHTML = ""
		resultsContainer.innerHTML = "";
		cities.forEach((city) => {
			const li = document.createElement("li");
			li.className = "location-search-suggestion";
      li.id = city.place_id
			li.appendChild(document.createTextNode(city.description));
			resultsContainer.appendChild(li);
      li.addEventListener('click', () => {
				input.value = city.description;
				resultsContainer.innerHTML = "";
				input.focus()
      })
		});
	};

	input.addEventListener("input", (e) => {
		const query = e.target.value;
		if (!query) {
			resultsContainer.innerHTML = "";
			return;
		}
		service.getQueryPredictions({
			input: query,
			types: ["geocode"],
			componentRestrictions: { country: "us" }
		}, displaySuggestions);
	});

	form.addEventListener('submit', e => {
		e.preventDefault()
		window.location.href = `https://locations.waxcenter.com/?q=${encodeURIComponent(input.value)}`;
	})
}

window.initService = initService; // add suggestions to DOM with custom elements so we can style them
// window.initAutocomplete = initAutocomplete // add suggestions to DOM automatically in Google Maps API style

const placesApiScript = document.createElement("script")
placesApiScript.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBvzJyjhVU2hB3fAVj0H3giihjE5yn579U&libraries=places&callback=initService" // custom suggestion elements
placesApiScript.async = true
placesApiScript.defer = true
document.head.appendChild(placesApiScript)
